<template>
  <div class="content">

    <!-- 筛选 -->
    <div style="overflow: hidden">
      <el-input v-model="name"
        placeholder="请输入存储名称"
        style="width:300px;margin-right: 20px;float: left"
        clearable>
        <el-button slot="append"
          icon="el-icon-search"
          @click="loadFormData" />
      </el-input>
      <el-select v-model="type"
        placeholder="请选择"
        @change="loadFormData"
        style="float: left">
        <el-option v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <el-button @click="handleAdd"
        type="success"
        size="medium"
        icon="el-icon-circle-plus-outline"
        class="addBtn">
        添加配置
      </el-button>
    </div>
    <!-- 表格 -->
    <el-table :data="configData.data"
      style="margin: 10px 0 15px 0;"
      :height="tableHt"
      border
      size="small"
      :highlight-current-row="true">
      <el-table-column label="序号"
        type="index"></el-table-column>
      <el-table-column label="存储名称"
        width="130"
        prop="name"
        align="center" />
      <el-table-column label="存储类型"
        :formatter="typeFormat"
        width="130"
        prop="type"
        align="center" />
      <el-table-column label="自定义域名"
        width="130"
        prop="domain"
        align="center"
        :show-overflow-tooltip="true" />
      <el-table-column label="EndPoint"
        prop="endPoint"
        align="left"
        header-align="center"
        :show-overflow-tooltip="true" />
      <el-table-column label="InnerEndPoint"
        prop="innerEndPoint"
        align="left"
        header-align="center"
        :show-overflow-tooltip="true" />
      <el-table-column label="桶名"
        prop="bucketName"
        align="left"
        header-align="center"
        :show-overflow-tooltip="true" />
      <el-table-column label="是否公开桶"
        :formatter="boolFormat"
        prop="isPublic"
        align="left"
        header-align="center" />
      <el-table-column label="操作"
        width="300"
        align="center">
        <template slot-scope="scope">
          <el-button size="mini"
            type="info"
            @click="handleDetil(scope.$index, scope.row)">详情</el-button>
          <el-button size="mini"
            type="primary"
            @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination background
      layout="prev, pager, next"
      style="display: flex;justify-content: center"
      :page-count="configData.pageTotal"
      :current-page.sync="configData.curPage"
      @current-change="handlePageChange"
      :page-size="configData.pageSize"></el-pagination>

    <!-- 编辑添加 -->
    <el-dialog :title="title"
      :visible.sync="editDlg">
      <el-form :inline="true"
        :model="curStorage"
        label-width="100px"
        v-if="editDlg"
        style="text-align:left">
        <el-form-item label="存储名称"
          :rules="{required: true, message: '存储名称不能为空', trigger: 'blur'}">
          <el-input v-model="curStorage.name"
            placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="存储类型"
          :rules="{required: true, message: '请选择存储类型', trigger: 'blur'}">
          <el-select v-model="curStorage.type"
            placeholder="请选择"
            style="float: left">
            <el-option v-for="item in options1"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <br>
        <el-form-item label="自定义域名"
          :rules="{required: true, message: '自定义域名不能为空', trigger: 'blur'}">
          <el-input v-model="curStorage.domain"
            style="width:500px"
            placeholder=""></el-input>
        </el-form-item>
        <br>
        <el-form-item label="Key"
          :rules="{required: true, message: '存储key不能为空', trigger: 'blur'}">
          <el-input v-model="curStorage.key"
            style="width:500px"
            placeholder=""></el-input>
        </el-form-item>
        <br>
        <el-form-item label="Secret"
          :rules="{required: true, message: '存储secret不能为空', trigger: 'blur'}">
          <el-input v-model="curStorage.secret"
            style="width:500px"
            placeholder=""></el-input>
        </el-form-item>
        <br>
        <el-form-item label="存储地址"
          :rules="{required: true, message: '存储地址不能为空', trigger: 'blur'}">
          <el-input v-model="curStorage.endPoint"
            style="width:500px"
            placeholder=""></el-input>
        </el-form-item>
        <br>
        <el-form-item label="内部地址"
          :rules="{required: true, message: '内部存储地址不能为空', trigger: 'blur'}">
          <el-input v-model="curStorage.innerEndPoint"
            style="width:500px"></el-input>
        </el-form-item>
        <br>
        <el-form-item label="桶名"
          :rules="{required: true, message: '通名不能为空', trigger: 'blur'}">
          <el-input v-model="curStorage.bucketName"></el-input>
        </el-form-item>
        <el-form-item label="是否公开">
          <el-select v-model="curStorage.isPublic"
            placeholder="请选择"
            style="float: left">
            <el-option v-for="item in isPublicSelect"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer"
        class="dialog-footer">
        <el-button @click="editDlg = false">取 消</el-button>
        <el-button type="primary"
          @click="handleSave">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 详情页 -->
    <el-dialog title="详情"
      :visible.sync="detil"
      width="700px">
      <div class="detil">
        <el-row>
          <el-col :span="3">
            <el-tag>存储名称：</el-tag>
          </el-col>
          <el-col :span="7"
            :offset="1">
            <el-tag type="info">{{curStorage.name}}</el-tag>
          </el-col>
          <el-col :span="3"
            :offset="2">
            <el-tag>存储类型：</el-tag>
          </el-col>
          <el-col :span="7"
            :offset="1">
            <el-tag type="info">{{curStorage.type}}</el-tag>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <el-tag>自定义域名</el-tag>
          </el-col>
          <el-col :span="7"
            :offset="1">
            <el-tag type="info">{{curStorage.domain}}</el-tag>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <el-tag>存储key：</el-tag>
          </el-col>
          <el-col :span="7"
            :offset="1">
            <el-tag type="info">{{curStorage.key}}</el-tag>
          </el-col>
          <el-col :span="3"
            :offset="2">
            <el-tag>存储secret：</el-tag>
          </el-col>
          <el-col :span="7"
            :offset="1">
            <el-tag type="info">{{curStorage.secret}}
            </el-tag>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <el-tag>存储地址：</el-tag>
          </el-col>
          <el-col :span="20"
            :offset="1">
            <el-tag type="info">{{curStorage.endPoint}}
            </el-tag>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <el-tag>内部存储地址：</el-tag>
          </el-col>
          <el-col :span="20"
            :offset="1">
            <el-tag type="info">{{curStorage.innerEndPoint}}</el-tag>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <el-tag>存储桶：</el-tag>
          </el-col>
          <el-col :span="7"
            :offset="1">
            <el-tag type="info">{{curStorage.bucketName}}
            </el-tag>
          </el-col>
          <el-col :span="3"
            :offset="2">
            <el-tag>是否公开：</el-tag>
          </el-col>
          <el-col :span="7"
            :offset="1">
            <el-tag type="info">{{curStorage.isPublic}}
            </el-tag>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <el-tag>创建时间：</el-tag>
          </el-col>
          <el-col :span="7"
            :offset="1">
            <el-tag type="info"> {{curStorage.createTime}}</el-tag>
          </el-col>
        </el-row>
      </div>
      <span slot="footer"
        class="dialog-footer">
        <el-button type="primary"
          size="small"
          @click="detil = false">关 闭</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import util from '../lib/util.js';
  import { getPageList, addStorage, updateStorage, deleteStorage } from '../Service/storageManage';
  import { debug } from 'util';

  export default {
    components: {},
    data() {
      return {
        title: '',
        editDlg: false,
        detil: false,
        curStorage: {},
        configData: { id: 0, data: [], pageSize: 15, curPage: 1, pageTotal: 1 },
        timer: null,
        refreshInterval: 10000, //刷新时间间隔
        treeProp: {
          label: 'fName',
          children: '',
          isLeaf: 'leaf'
        },
        value: null,
        options: [
          {
            label: '全部'
          },
          {
            value: 'huawei',
            label: '华为云'
          },
          {
            value: 'ali',
            label: '阿里云'
          },
          {
            value: 'aws',
            label: 'AWS'
          }
        ],
        options1: [
          {
            value: 'huawei',
            label: '华为云'
          },
          {
            value: 'ali',
            label: '阿里云'
          },
          {
            value: 'aws',
            label: 'AWS'
          }
        ],
        isPublicSelect: [
          {
            value: 1,
            label: '是'
          },
          {
            value: 0,
            label: '否'
          }
        ],
        name: null,
        type: null
      };
    },
    computed: {
      isAnyDlg() {
        return this.editDlg || this.detil;
      },
      tableHt() {
        return 'calc(100vh - 190px)';
      }
    },

    mounted() {
      this.loadFormData();
    },

    methods: {
      filterevn(value, row, column) {
        const property = column['property'];
        return row[property] === value;
      },

      /* ------------ 按钮点击响应方法开始  ------------*/
      handleDetil(index, data) {
        this.curStorage = Object.assign({}, data);
        this.curStorage.createTime = util.formatDateTime(this.createTime.createTime);
        this.detil = true;
      },

      handleEdit(index, data) {
        this.title = '编辑';
        this.curStorage = Object.assign({}, data);
        this.editDlg = true;
      },

      handleDelete(index, data) {
        this.$confirm('此操作将删除该配置, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteStorage({ id: data.id })
            .then((r) => {
              if (r.code === 200) {
                this.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.loadFormData();
              } else {
                this.$message.error(r.message);
              }
            })
            .catch((r) => this.$message.error(r.message));
        });
      },

      handleAdd() {
        this.curStorage = {};
        this.title = '添加';
        this.editDlg = true;
      },

      handleSave() {
        if (!this.curStorage.name) {
          this.$message.error('存储名称不能为空');
          return;
        }
        if (!this.curStorage.type) {
          this.$message.error('存储类型不能为空');
          return;
        }
        if (!this.curStorage.domain) {
          this.$message.error('自定义域名不能为空');
          return;
        }
        if (!this.curStorage.key) {
          this.$message.error('存储key不能为空');
          return;
        }
        if (!this.curStorage.secret) {
          this.$message.error('存储secret不能为空');
          return;
        }
        if (!this.curStorage.endPoint) {
          this.$message.error('存储endPoint不能为空');
          return;
        }
        if (!this.curStorage.innerEndPoint) {
          this.$message.error('存储innerEndPoint不能为空');
          return;
        }
        if (!this.curStorage.bucketName) {
          this.$message.error('存储桶名不能为空');
          return;
        }
        this.title === '编辑' ? this.saveEdit() : this.addConfig();
      },

      handlePageChange() {
        this.loadFormData();
      },

      logPageChange() {
        this.loadLogData();
      },

      /* ------------- 按钮点击响应方法结束 -------------*/

      // 修改storage数据
      saveEdit() {
        this.curStorage.createTime = new Date();
        updateStorage(this.curStorage).then((r) => {
          if (r.code === 200) {
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            this.loadFormData();
            this.editDlg = false;
          } else {
            this.$message.error(r.message);
          }
        });
      },

      // 添加storage数据
      addConfig() {
        this.curStorage.createTime = new Date();
        addStorage(this.curStorage).then((r) => {
          if (r.code === 200) {
            this.$message({
              message: '添加成功',
              type: 'success'
            });
            this.loadFormData();
            this.editDlg = false;
          } else {
            this.$message.error(r.message);
          }
        });
      },

      formaTime(row, column, cellValue, index) {
        return util.formatDateTime(cellValue);
      },
      // 加载storage表格数据
      loadFormData() {
        getPageList({
          page: this.configData.curPage,
          size: this.configData.pageSize,
          type: this.type,
          name: this.name
        })
          .then((r) => {
            console.log(r);
            if (r?.code == 200) {
              this.configData.data = r.data.list;
              this.configData.pageTotal = r.data.lastPage;
            } else {
              this.$message.error(r.message);
              console.log(r);
            }
          })
          .catch((r) => console.log(r));
      },

      typeFormat(storage) {
        if (storage.type == 'huawei') {
          return '华为云';
        } else if (storage.type == 'ali') {
          return '阿里云';
        } else if (service.type == 'aws') {
          return 'AWS';
        } else {
          return '未知';
        }
      },
      boolFormat(storage) {
        if (storage.isPublic == 1) {
          return '是';
        } else {
          return '否';
        }
      }
    }
  };
</script>
<style lang="scss" scoped>
  $pryClr: #3399ff;
  $pryClrL: #5cadff;
  $pryClrD: #3091f2;
  $infoClr: #3399ff;
  $successClr: #00cc66;
  $wrnClr: #ff9900;
  $errorClr: #ff6600;
  $dividerClr: #e3e8ee;
  $bgc: #f5f7f9;
  $contentClr: #657180;
  $titleClr: #464c5b;
  $topHt: 60px;
  $spbd: #d7dde4 1px solid;

  .content {
    width: calc(100vw - 40px);
    height: calc(100vh - 100px);
    padding: 20px 20px 10px 20px;
    background-color: #fff;
    .addBtn {
      display: block;
      float: right;
    }

    .top {
      font-size: 14px;
      margin-bottom: 5px;
      border: $spbd;
      padding: 4px;
    }
  }

  .detil {
    text-align: left;

    .value {
      margin-left: 10px;
      width: 120px;
      border: $spbd;
      border-radius: 4px;
    }
    .el-row {
      padding: 4px 0;
      .el-tag {
        display: block;
        width: 100%;
      }
    }
  }

  .regionPane {
    position: absolute;
    z-index: 10;
    background-color: #fff;

    .scrollpane {
      border: $spbd;
      border-radius: 5px;
      .el-scrollbar__wrap {
        overflow: scroll;
        overflow-x: auto;
        .tree {
          padding: 5px;
          width: 250px;
          max-height: 200px;
        }
      }
    }
  }
</style>
